import SvgIcon from './SvgIcon';
export default SvgIcon;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-svgicon/src/index.js